module.exports = __webpack_public_path__ + "img/fs-banner.6fe1aaf9.svg";